import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

interface Haha {
  name: string
  age: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'composibleApiTest',
  setup(__props) {

const obj: Haha = {
  name: '123',
  age: 1234,
}
// 响应式状态
const count = ref(0)

// 更改状态、触发更新的函数
function increment() {
  count.value++
}

return { __sfc: true,obj, count, increment }
}

})